require('es6-promise').polyfill();
import axios from 'axios';
import store from './store'

import baseURL from './env'
import router from './router'
import {Message} from "element-ui";
import tools from "./utils/tool";

const instance = axios.create({
    // baseURL,
    timeout: -1
});

instance.interceptors.request.use(function (config) {
    // config.headers["authorization"] = store.getters.token;
    config.headers["account"] = store.getters.account;
    config.headers["token"] = store.getters.token;
    // config.headers["menuCode"] = tools.getUrlParams('menuCode');
    // console.log('router', router.currentRoute.valueOf());
    const menuKey = router.currentRoute.valueOf().meta.menuKey
    if (menuKey !== 'Login') {
      let map = JSON.parse(localStorage.getItem("elearningMenuMap"));
      config.headers["menuCode"] = map[menuKey] || ''
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});

instance.interceptors.response.use(function (response) {
    if(!response.data) {
      return response;
    }
    if (response.data.code === 401){
      Message.warning(response.data.message)
      router.push("/login")
    }else if (response.data.code === 403){
      Message.warning(response.data.message)
    }
    return response;
}, function (error) {
    return Promise.reject(error);
});

export default instance



// WEBPACK FOOTER //
// ./src/axios.js